export const dashboard = {
  title: "Dashboard",
  filters: {
    accommodation: "Unterkunft",
    allAccommodations: "Alle Unterkünfte",
    period: "Zeitraum",
    periodOptions: {
      today: "Heute",
      week: "Woche",
      month: "Monat",
      year: "Jahr",
    },
  },
  actions: {
    createBooking: "Buchung anlegen",
  },
  pendingWidget: {
    title: "Offene Aufgaben",
    subtitle: "Zahlungen, Anfragen und zuzuweisende Zimmer.",
    oneRequest: "Anfrage",
    manyRequests: "Anfragen",
    onePayment: "Zahlung",
    manyPayments: "Zahlungen",
    oneUnassigned: "zuzuweisen",
    manyUnassigned: "zuzuweisen",
    loading: "Offene Aufgaben werden geladen...",
    emptyTitle: "Keine offenen Aufgaben",
    emptyText: "Sobald eine neue Anfrage eingeht oder eine Buchung auf Zahlung wartet, erscheint sie hier.",
    noName: "Ohne Namen",
    accommodation: "Unterkunft",
    guest: "Gast",
    guests: "Gäste",
    requestShort: "Anfrage",
    pendingPaymentShort: "Wartet auf Zahlung",
    unassignedShort: "Zimmer zuweisen",
    approve: "Bestätigen",
    reject: "Ablehnen",
    viewAll: "Alle Buchungen ansehen",
    modalApproveTitle: "Anfrage bestätigen",
    modalRejectTitle: "Anfrage ablehnen",
    modalApproveText1: "Sie sind dabei, die Anfrage zu bestätigen von",
    modalApproveText2: "Wenn für diese Buchung Online-Zahlung gilt, wechselt sie in den Status Wartet auf Zahlung.",
    modalRejectText1: "Sie sind dabei, die Anfrage abzulehnen von",
    modalRejectText2: "Sie können einen Grund angeben, der dem Gast per E-Mail gesendet wird.",
    rejectReasonLabel: "Ablehnungsgrund",
    rejectReasonPlaceholder: "Grund auswählen",
    reasonDatesUnavailable: "Die Daten sind nicht mehr verfügbar",
    reasonPriceUnavailable: "Der Tarif ist nicht mehr verfügbar",
    reasonMinimumStay: "Mindestaufenthalt nicht erfüllt",
    reasonHouseRules: "Regeln der Unterkunft nicht erfüllt",
    reasonOther: "Anderer Grund",
    rejectReasonOtherPlaceholder: "Ablehnungsgrund schreiben",
    rejectReasonRequired: "Sie müssen einen Ablehnungsgrund auswählen.",
    rejectReasonOtherRequired: "Sie müssen den Ablehnungsgrund schreiben.",
    cancel: "Abbrechen",
    confirmApprove: "Ja, bestätigen",
    confirmReject: "Ja, ablehnen",
    statusUpdatedSuccess: "Status erfolgreich aktualisiert.",
    statusUpdatedError: "Der Status konnte nicht aktualisiert werden."
  },

  stats: {
    totalReservations: {
      today:   "Buchungen heute",
      week:    "Buchungen diese Woche",
      month:   "Buchungen diesen Monat",
      year:    "Buchungen dieses Jahr",
      default: "Buchungen gesamt",
    },
    checkIns: {
      today:   "Check-ins heute",
      week:    "Check-ins diese Woche",
      month:   "Check-ins diesen Monat",
      year:    "Check-ins dieses Jahr",
      default: "Check-ins",
    },
    occupancy: {
      today:   "Auslastung heute",
      week:    "Auslastung der Woche",
      month:   "Auslastung des Monats",
      year:    "Auslastung des Jahres",
      default: "Auslastung",
    },
    revenue: {
      today:   "Umsatz heute",
      week:    "Umsatz der Woche",
      month:   "Umsatz des Monats",
      year:    "Umsatz des Jahres",
      default: "Umsatz",
    },
  },
  section3: {
    title: "Kommende Buchungen",
    subtitle: "Liste der kommenden Anreisen in Ihrer Unterkunft",
    timeFilters: {
      upcoming: "Kommende",
      thisWeek: "Diese Woche",
      today: "Heute",
      tomorrow: "Morgen",
      month: "Monat",
    },
    table: {
      headers: {
        responsible: "Verantwortlich",
        checkInDate: "Check-in-Datum",
        entry: "Anreise",
        guests: "Gäste",
        status: "Status",
      },
    },
    empty: {
      today: {
        title: "Sie haben heute keine Anreisen",
        description:
          "Sobald für heute eine neue Anreise geplant ist, erscheint sie hier mit allen wichtigen Angaben.",
      },
      default: {
        title: "Sie haben keine kommenden Anreisen",
        description:
          "Sobald neue Anreisen geplant sind, erscheinen sie hier mit allen wichtigen Angaben.",
      },
    },
    loading: "Buchungen werden geladen...",
    statuses: {
      inProgress: "In Bearbeitung",
      complete: "Abgeschlossen",
      pending: "Ausstehend",
      approved: "Bestätigt",
    },
    actions: {
      replyOnWhatsApp: "Auf WhatsApp antworten",
    },
    nights: "{count} Nacht | {count} Nächte",
  },
  section4: {
    title: "Umsatzaufteilung",
    total: "Gesamtumsatz",
    emptyChart: "Keine Daten verfügbar",
    noData: "Es gibt keine Umsatzdaten zum Anzeigen",
  },
  section5: {
    title: "Gesamtumsatz",
    datasetLabel: "Umsatz",
    filters: {
      weekly: "Wöchentlich",
      monthly: "Monatlich",
      "6m": "6 Monate",
      "12m": "12 Monate",
      "24m": "24 Monate",
    },
    loading: "Daten werden geladen...",
    errors: {
      load: "Fehler beim Laden der Daten",
      connection: "Verbindungsfehler",
    },
  },
  design: {
    title: `Design des Dashboards`,
    reorder: `Sortieren`,
    active: `Aktiv`,
    theme: `Design`,
    color: `Farbe`,
    green: `Grün`,
    system: `System`,
    white: `Weiß`,
    sidebar: `Seitenleiste`,
    black: `Schwarz`,
  },
  earlyCheckin: {
    earlyShort: `Früh`,
    arrivesShort: `Ankunft`,
    arrivalAt: `Um {time}`,
    requested: `Früher Check-in angefragt`,
    arrivalRequested: `Ankunftszeit angefragt`,
  },
};
